import Sidebar from "../../Components/Sidebar";
import { useParams, useLocation } from "react-router-dom";
import overview from "../../assest/dashboard b.png";
import targetgroup from "../../assest/2.png";
import targetuser from "../../assest/dashboard a.png";
import { useEffect, useState } from "react";
import ChartCard from "../../Components/Charts/DetailCompaignGraph";
import { useSelector } from "react-redux";
import { Table, Button } from "antd";
import {
  detailCampaign,
  getCampaign,
} from "../../redux/actions/campaignaction";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { DownloadOutlined } from "@ant-design/icons";
import { format } from "date-fns-tz";
import { base_url } from "../../Config/Constant";
const CampaignDetails = () => {
  const { id } = useParams();
  const location = useLocation();
  const campaignFromState = location.state?.campaign;

  const formatDate = (dateString) => {
    return dateString
      ? format(new Date(dateString), "yyyy-MM-dd HH:mm:ss", {
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, // Detects user's timezone
        })
      : "N/A";
  };

  const [campaignName, setCampaignName] = useState(
    campaignFromState?.name || null
  );

  const campaignsList = useSelector(
    (state) => state?.campaignReducer?.Allcampaign?.usercampaign
  );

  useEffect(() => {
    // Scroll to top when component mounts or id changes
    window.scrollTo(0, 0);
  }, [id]);

  useEffect(() => {
    if (!campaignName && campaignsList && id) {
      const campaign = campaignsList.find((c) => c._id === id);
      if (campaign) {
        setCampaignName(campaign.name);
      }
    }
  }, [campaignsList, id, campaignName]);

  useEffect(() => {
    const fetchCampaignName = async () => {
      if (!campaignName && id) {
        try {
          const organizationid = localStorage.getItem("organizationid");
          if (organizationid) {
            await getCampaign({ organizationid, page: 1 });
          }
        } catch (error) {
          console.error("Error fetching campaigns list:", error);
        }
      }
    };
    fetchCampaignName();
  }, [campaignName, id]);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) {
        console.warn("Campaign ID is missing");
        return;
      }

      try {
        let campaignid = id;
        let page = 1;
        let payload = { campaignid, page };

        await detailCampaign(payload);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData(); // Call the fetchData function
  }, [id]);

  const allcampaign = useSelector(
    (state) => state?.campaignReducer?.Allcampaign
  );

  // Get campaign date from multiple sources
  const getCampaignDate = () => {
    // First try: from location state (if navigated from campaigns list)
    if (campaignFromState?.createdDate) {
      return campaignFromState.createdDate.split("T")[0];
    }

    // Second try: from campaigns list
    if (campaignsList && id) {
      const campaign = campaignsList.find((c) => c._id === id);
      if (campaign?.createdDate) {
        return campaign.createdDate.split("T")[0];
      }
    }

    // Third try: from allcampaign.data (fallback)
    if (allcampaign?.data && allcampaign.data.length > 0) {
      const date = allcampaign.data[0]?.campaignid?.createdAt;
      if (date) {
        return date.split("T")[0];
      }
    }

    return "/";
  };

  const [selectedCard, setSelectedCard] = useState(null);

  const handleCardClick = (cardIndex) => {
    setSelectedCard(cardIndex);
    setColornumber(cardIndex);
  };

  const [colornumber, setColornumber] = useState(null);

  const handleDownloadReport = () => {
    const token = localStorage.getItem('token');
    window.open(`${base_url}/report/campaign/${id}?token=${token}`, '_blank');
  };

  const columns = [
    {
      title: "Username",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone Number",
      dataIndex: "phone",
      key: "phone",
    },

    {
      title: "Date & Time",
      dataIndex: "dateTime",
      key: "dateTime",
    },

    {
      title: "User Agent String",
      dataIndex: "deviceInfo",
      key: "deviceInfo",
    },
  ];

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  // Row Selection Configuration
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
  };
  console.log("test", allcampaign);
  return (
    <div className="dashboard">
      <Sidebar />
      <div className="dashboard-right-side space-y-6">
        <div className="flex gap-3 items-start text-[#4A4D54] justify-between">
          <div className="flex gap-3 items-start">
            <div className="h-8 flex items-center justify-center">
              <button
                className="border-0 bg-transparent p-0 cursor-pointer flex items-center justify-center"
                onClick={() => window.history.back()}
              >
                <IoArrowBackCircleOutline size={28} />
              </button>
            </div>
            <div>
              <h5 className="text-2xl font-bold mb-0">
                {campaignName ||
                  (allcampaign?.data || [])[0]?.campaignid?.name ||
                  "No Campaign"}
              </h5>

              <p className="text-[#3A3B3F] text-xs">{getCampaignDate()}</p>
            </div>
          </div>
          <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={handleDownloadReport}
          >
            Download Report
          </Button>
        </div>
        {/* <div className="stats">
          <div className="statsbox">
            <div className="statsheading">
              Users Contacted

              <h1>{allcampaign?.data2?.totalusers}</h1>

            </div>
            <img className="statsimg" src={overview} alt="" />
          </div>

          <div className="statsbox">
            <div className="statsheading">
              Total % Clicked

              <h1>{allcampaign?.data2?.isLoginFalse}</h1>

            </div>
            <img className="statsimg" src={targetgroup} alt="" />
          </div>

          <div className="statsbox">
            <div className="statsheading">

              Total %  Logged In
              <h1>{allcampaign?.data2?.isLoginTrue}</h1>

            </div>
            <img className="statsimg" src={targetuser} alt="" />
          </div>
        </div> */}
        <div className="row mt-3">
          {/* Card 1 - Total Campaigns */}
          <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
            <div className="d-flex justify-content-between pt-4 statsbox px-4 h-100">
              <div className="statsheading">
                <p className="statSize mb-1 text-muted"> Users Contacted</p>
                <h1>{allcampaign?.data2?.totalusers}</h1>
              </div>
              <img className="statsimg" src={overview} alt="Overview" />
            </div>
          </div>

          {/* Card 2 - Total Target Users */}
          <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
            <div className="d-flex justify-content-between pt-4 statsbox p-4 h-100">
              <div className="statsheading">
                <p className="statSize mb-1 text-muted"> Total Clicked</p>
                <h1>{allcampaign?.data2?.isLoginFalse}</h1>
              </div>
              <img className="statsimg" src={targetgroup} alt="Target Group" />
            </div>
          </div>

          {/* Card 3 - Total User Groups */}
          <div className="col-sm-12 col-md-6 col-lg-4 mb-4">
            <div className="d-flex justify-content-between pt-4 statsbox p-4 h-100">
              <div className="statsheading">
                <p className="statSize mb-1 text-muted">Total Logged In</p>
                <h1>{allcampaign?.data2?.isLoginTrue}</h1>
              </div>
              <img className="statsimg" src={targetuser} alt="Target User" />
            </div>
          </div>
        </div>

        <div className="graphmain">
          <ChartCard
            title="Number of User Clicked"
            dataKey="Clicks"
            color="#B91C1C"
            data={allcampaign?.data2?.weekly}
            selected={selectedCard === 0}
            onClick={() => handleCardClick(0)}
            colornumber={colornumber}
          />
        </div>

        <div className="">
          <div className="flex items-center justify-between gap-3 mb-4">
            <h6 className="max-w-[150px] w-full p-0 m-0 text-[#3A3B3F] text-xl font-medium">
              User Clicked
            </h6>
            {/* <div className="w-full flex gap-3">
              <Select
                placeholder="Username"
                className="w-full"
                options={[
                  { value: "jack", label: "Jack" },
                  { value: "lucy", label: "Lucy" },
                  { value: "Yiminghe", label: "yiminghe" },
                ]}
              />
              <Select
                placeholder="User Clicked"
                className="w-full"
                options={[
                  { value: "jack", label: "Jack" },
                  { value: "lucy", label: "Lucy" },
                  { value: "Yiminghe", label: "yiminghe" },
                ]}
              />
              <Select
                placeholder="Credential Entered"
                className="w-full"
                options={[
                  { value: "no", label: "No" },
                  { value: "yes", label: "Yes" },
                ]}
              />
              <Button danger>
                <BiExport size={18} />
                Export
              </Button>
            </div> */}
          </div>

          <Table
            className="table"
            rowSelection={rowSelection}
            dataSource={allcampaign?.data
              ?.filter((c) => c.islogin === false)
              .map((c, i) => ({
                key: i,
                name: c.userid ? c.userid?.Name : c.freeuserid?.name,
                email: c.userid ? c.userid?.email : c.freeuserid?.email,
                phone: c.userid ? c.userid?.phone : c.freeuserid?.phone,

                dateTime: formatDate(c.createdAt),
                deviceInfo: c.deviceInfo,
              }))}
            columns={columns}
          />

          <div className="flex items-center justify-between gap-3 mb-4">
            <h6 className="max-w-[150px] w-full p-0 m-0 text-[#3A3B3F] text-xl font-medium">
              User Logged In
            </h6>
            {/* <div className="w-full flex gap-3">
              <Select
                placeholder="Username"
                className="w-full"
                options={[
                  { value: "jack", label: "Jack" },
                  { value: "lucy", label: "Lucy" },
                  { value: "Yiminghe", label: "yiminghe" },
                ]}
              />
              <Select
                placeholder="User Clicked"
                className="w-full"
                options={[
                  { value: "jack", label: "Jack" },
                  { value: "lucy", label: "Lucy" },
                  { value: "Yiminghe", label: "yiminghe" },
                ]}
              />
              <Select
                placeholder="Credential Entered"
                className="w-full"
                options={[
                  { value: "no", label: "No" },
                  { value: "yes", label: "Yes" },
                ]}
              />
              <Button danger>
                <BiExport size={18} />
                Export
              </Button>
            </div> */}
          </div>

          <Table
            className="table"
            rowSelection={rowSelection}
            dataSource={allcampaign?.data
              ?.filter((c) => c.islogin === true)
              .map((c, i) => ({
                key: i,
                name: c.userid ? c.userid?.Name : c.freeuserid?.name,
                email: c.userid ? c.userid?.email : c.freeuserid?.email,
                phone: c.userid ? c.userid?.phone : c.freeuserid?.phone,
                dateTime: formatDate(c.createdAt),
                deviceInfo: c.deviceInfo,
              }))}
            columns={columns}
          />
        </div>
      </div>
    </div>
  );
};

export default CampaignDetails;
